"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _market = require("@/api/market");
var _merchant = require("@/api/merchant");
var _pagesHeader = _interopRequireDefault(require("@/components/base/pagesHeader"));
var _system = require("@/api/system");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _require = require('@/utils/regionCode'),
  resolveMapRegionIds = _require.resolveMapRegionIds,
  buildRegionSelectionPath = _require.buildRegionSelectionPath,
  resolveRegionSelection = _require.resolveRegionSelection;
var _default = exports.default = {
  name: 'MarketAdd',
  components: {
    PagesHeader: _pagesHeader.default
  },
  data: function data() {
    return {
      currentTab: '1',
      headTab: [{
        tit: '基础信息',
        name: '1'
      }, {
        tit: '摊位信息',
        name: '2'
      }, {
        tit: '详细信息',
        name: '3'
      }],
      isEdit: false,
      isDisabled: false,
      submitLoading: false,
      saveStepLoading: false,
      regionLoading: false,
      regionOptions: [],
      regionProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      searchRegionProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: true
      },
      // 地图相关数据
      mapDialogVisible: false,
      searchKeyword: '',
      searchResults: [],
      showSearchResults: false,
      hasMoreResults: false,
      loadingMore: false,
      currentPage: 1,
      pageSize: 20,
      selectedSearchResult: null,
      searchLoading: false,
      searchNoDataText: '请输入地点名称搜索',
      currentSearchKeyword: '',
      // 存储当前搜索关键词
      searchScope: 'current',
      searchRegionCode: [],
      specifiedSearchCity: '',
      searchRequestId: 0,
      selectedAddress: '',
      selectedLocationName: '',
      selectedLng: '',
      selectedLat: '',
      selectedAddressDetail: null,
      reverseGeocodeLoading: false,
      reverseGeocodeRequestId: 0,
      selectionNeedsGeocode: false,
      currentCity: '',
      currentCityCode: '',
      tencentMap: null,
      tencentMarker: null,
      geolocationInstance: null,
      // 腾讯地图定位实例
      mapControlsAdded: false,
      mapEventsBound: false,
      regionDisplayText: '',
      // 省市区显示文本
      // 字段提示信息
      fieldTooltips: {
        marketName: '集市名称用于主办方内部管理，不会对外展示给用户',
        marketType: '长期：持续经营的集市；短期：临时性或限时经营的集市',
        environmentType: '室内：在建筑物内部的集市；室外：在露天环境的集市',
        siteType: '根据集市所在的地理位置类型进行分类',
        regionCode: '优先手动选择省市区，地图选点后也会自动同步这里的结果',
        area: '集市的占地面积，单位为平方米',
        capacity: '集市最多能容纳的摊位数量',
        detail: '集市的详细地址，建议通过地图选择确保准确性',
        marketAreaList: '设置集市的区域划分和每个区域内的摊位位置',
        marketLayoutImgs: '上传集市的平面布局图，帮助用户了解摊位分布',
        customerType: '描述主要客户群体，如：年轻白领、亲子家庭、老年人等',
        dailyVisitorCount: '预估的日均客流量，如：60000-80000人/天',
        facilities: '选择集市提供的设施和服务',
        marketImgs: '上传集市的实景照片，最多20张',
        marketInfo: '详细描述集市的特色、优势等信息',
        contactPerson: '集市负责人的姓名',
        contactPhone: '集市负责人的联系电话',
        marketOwnerPhoto: '上传集市主用于沟通的微信二维码，需保持清晰可识别',
        remark: '其他需要说明的信息'
      },
      // 商户选择
      merchantOptions: [],
      merchantLoading: false,
      form: {
        id: null,
        merId: null,
        marketName: '',
        marketType: 0,
        environmentType: 0,
        siteType: 1,
        regionCode: [],
        province: '',
        city: '',
        district: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        street: '',
        detail: '',
        area: '',
        capacity: '',
        contactPerson: '',
        contactPhone: '',
        marketOwnerPhoto: '',
        customerType: '',
        dailyVisitorCount: '',
        facilities: [],
        // 集市设施（多选）
        marketInfo: '',
        marketImgs: [],
        // 集市图片（最多20张）
        marketLayoutImgs: [],
        // 摊位分布图（最多9张）
        marketAreaList: [],
        // 摊位设置区域列表
        remark: '',
        latitude: '',
        longitude: '',
        status: 1 // 默认下架状态
      },
      rules: {
        merId: [{
          required: true,
          message: '请选择关联商户',
          trigger: 'change'
        }],
        marketName: [{
          required: true,
          message: '请输入集市名称',
          trigger: 'blur'
        }, {
          max: 50,
          message: '集市名称不能超过50个字符',
          trigger: 'blur'
        }],
        marketType: [{
          required: true,
          message: '请选择集市类型',
          trigger: 'change'
        }],
        environmentType: [{
          required: true,
          message: '请选择经营环境',
          trigger: 'change'
        }],
        siteType: [{
          required: true,
          message: '请选择集市属性',
          trigger: 'change'
        }],
        regionCode: [{
          required: true,
          message: '请选择省市区',
          trigger: 'change'
        }],
        area: [{
          validator: function validator(rule, value, callback) {
            if (value !== '' && value !== null && value !== undefined && value <= 0) {
              callback(new Error('集市面积必须大于0'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        capacity: [{
          validator: function validator(rule, value, callback) {
            if (value !== '' && value !== null && value !== undefined && value <= 0) {
              callback(new Error('容纳摊位数必须大于0'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        detail: [{
          required: true,
          message: '请选择详细地址',
          trigger: 'blur'
        }],
        marketAreaList: [
          // 移除必填验证，改为非必填
        ],
        marketLayoutImgs: [
          // 移除必填验证，改为非必填
        ],
        facilities: [{
          required: true,
          message: '请选择集市设施',
          trigger: 'change'
        }],
        marketImgs: [{
          required: true,
          message: '请上传集市图片',
          trigger: 'change'
        }],
        marketInfo: [{
          required: true,
          message: '请输入集市描述',
          trigger: 'blur'
        }],
        contactPerson: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    // 过滤出未删除的区域
    visibleAreas: function visibleAreas() {
      return this.form.marketAreaList.filter(function (area) {
        return !area.isDel;
      });
    }
  },
  created: function created() {
    this.initPage();
    // 预加载一页商户数据
    this.remoteSearchMerchant('');
  },
  methods: {
    // 初始化页面
    initPage: function initPage() {
      var id = this.$route.query.id;
      if (id && id !== '0') {
        this.isEdit = true;
        this.loadMarketInfo(id);
      }
      this.loadRegionData();
    },
    // 远程搜索商户（仅展示已开启的商户）
    remoteSearchMerchant: function remoteSearchMerchant(query) {
      var _this2 = this;
      this.merchantLoading = true;
      var params = {
        page: 1,
        limit: 20,
        isSwitch: true,
        keywords: (query || '').trim() || undefined
      };
      (0, _merchant.merchantListApi)(params).then(function (res) {
        var data = res && res.data && res.data.list ? res.data : res;
        var list = data && data.list || [];
        // 仅保留必要字段
        _this2.merchantOptions = list.map(function (item) {
          return {
            id: item.id,
            name: item.name
          };
        });
      }).finally(function () {
        _this2.merchantLoading = false;
      });
    },
    // 加载集市信息
    loadMarketInfo: function loadMarketInfo(id) {
      var _this3 = this;
      (0, _market.marketInfo)(id).then(function (data) {
        console.log('API返回的数据:', data);

        // 先处理特殊字段的数据转换
        var processedData = _objectSpread({}, data);

        // 处理摊位分布图数据
        if (data.marketLayoutImg) {
          try {
            processedData.marketLayoutImgs = JSON.parse(data.marketLayoutImg);
          } catch (error) {
            console.error('处理摊位分布图数据失败:', error);
          }
        }

        // 处理集市图片数据
        if (data.marketImg) {
          try {
            processedData.marketImgs = JSON.parse(data.marketImg);
          } catch (error) {
            console.error('处理集市图片数据失败:', error);
          }
        }
        // 处理集市设施数据
        if (data.marketSupporting) {
          processedData.facilities = data.marketSupporting.split(',').filter(function (facility) {
            return facility.trim();
          });
        }

        // 基础数据回显
        _this3.form = _objectSpread(_objectSpread({}, _this3.form), processedData);

        // 处理摊位设置数据回显
        if (data.marketAreaInfoRespList && data.marketAreaInfoRespList.length > 0) {
          _this3.form.marketAreaList = data.marketAreaInfoRespList.map(function (area) {
            return {
              id: area.id || null,
              // 保留区域ID
              areaName: area.areaName || '',
              areaRemark: area.areaRemark || '',
              isDel: false,
              // 默认未删除
              marketStallList: area.stallInfoRespList ? area.stallInfoRespList.map(function (stall) {
                return {
                  id: stall.id || null,
                  // 保留摊位ID
                  areaId: area.id || null,
                  // 设置区域ID
                  stallName: stall.stallName || '',
                  stallRemark: stall.stallRemark || '',
                  stallNum: stall.stallNum || 0,
                  isDel: false // 默认未删除
                };
              }) : []
            };
          });
        }

        // 处理摊位编号，确保编号连续
        if (_this3.form.marketAreaList && _this3.form.marketAreaList.length > 0) {
          _this3.form.marketAreaList.forEach(function (area, areaIndex) {
            _this3.updateStallNumbers(areaIndex);
          });
        }

        // 设置省市区显示文本
        _this3.updateRegionDisplayText();
        _this3.syncRegionSelectionFromForm();
        // 如果有坐标信息，设置地图相关数据
        if (data.longitude && data.latitude) {
          _this3.selectedLng = data.longitude;
          _this3.selectedLat = data.latitude;
          _this3.selectedAddress = data.detail || data.street;
        }
        console.log('处理后的表单数据:', _this3.form);
      });
    },
    // 加载地区数据
    loadRegionData: function loadRegionData() {
      var _this4 = this;
      this.regionLoading = true;
      (0, _system.cityListApi)().then(function (res) {
        _this4.regionOptions = res || [];
        _this4.syncRegionSelectionFromForm();
        _this4.regionLoading = false;
      }).catch(function () {
        _this4.regionLoading = false;
        _this4.$message.error('加载省市区数据失败');
      });
    },
    handleRegionChange: function handleRegionChange(values) {
      if (!values || !values.length) {
        this.form.regionCode = [];
        this.form.province = '';
        this.form.city = '';
        this.form.district = '';
        this.form.provinceId = '';
        this.form.cityId = '';
        this.form.districtId = '';
        this.currentCity = '';
        this.updateRegionDisplayText();
        return;
      }
      var regionData = resolveRegionSelection(this.regionOptions, values);
      this.form.regionCode = values;
      this.form.province = regionData.province;
      this.form.city = regionData.city;
      this.form.district = regionData.district;
      this.form.provinceId = regionData.provinceId;
      this.form.cityId = regionData.cityId;
      this.form.districtId = regionData.districtId;
      this.currentCity = regionData.city || regionData.province || '';
      this.updateRegionDisplayText();
    },
    // 地图搜索范围切换后重新搜索，避免旧范围的结果残留。
    handleSearchScopeChange: function handleSearchScopeChange(scope) {
      this.searchRequestId++;
      this.searchLoading = false;
      this.searchResults = [];
      this.hasMoreResults = false;
      this.currentPage = 1;
      this.searchNoDataText = scope === 'city' ? '请选择目标城市后搜索' : '请输入地点名称搜索';
      if (scope !== 'city') {
        this.searchRegionCode = [];
        this.specifiedSearchCity = '';
      }
      if (this.currentSearchKeyword && (scope !== 'city' || this.specifiedSearchCity)) {
        this.searchLocation(this.currentSearchKeyword);
      }
    },
    handleSearchCityChange: function handleSearchCityChange(values) {
      this.searchRequestId++;
      this.searchLoading = false;
      var regionData = resolveRegionSelection(this.regionOptions, values || []);
      this.specifiedSearchCity = regionData.city || '';
      this.searchResults = [];
      this.hasMoreResults = false;
      this.currentPage = 1;
      this.searchNoDataText = this.specifiedSearchCity ? '请输入地点名称搜索' : '请选择目标城市后搜索';
      if (this.specifiedSearchCity && this.currentSearchKeyword) {
        this.searchLocation(this.currentSearchKeyword);
      }
    },
    syncRegionSelectionFromForm: function syncRegionSelectionFromForm() {
      if (!this.regionOptions.length) return;
      this.form.regionCode = buildRegionSelectionPath(this.regionOptions, {
        provinceId: this.form.provinceId,
        cityId: this.form.cityId,
        districtId: this.form.districtId
      });
      this.currentCity = this.form.city || this.form.province || '';
    },
    // 更新省市区显示文本
    updateRegionDisplayText: function updateRegionDisplayText() {
      if (this.form.province && this.form.city && this.form.district) {
        this.regionDisplayText = "".concat(this.form.province, " ").concat(this.form.city, " ").concat(this.form.district);
      } else {
        this.regionDisplayText = '';
      }
    },
    // 打开地图选择
    openMapDialog: function openMapDialog() {
      var _this5 = this;
      if (this.isDisabled) {
        this.$message.info('详情模式下不允许修改地址');
        return;
      }
      this.searchScope = 'current';
      this.searchRegionCode = [];
      this.specifiedSearchCity = '';
      this.mapDialogVisible = true;
      // 等待Dialog渲染完成后初始化地图
      this.$nextTick(function () {
        setTimeout(function () {
          _this5.loadTencentMapAPI();
        }, 300);
        // 添加点击外部隐藏搜索结果的事件监听
        setTimeout(function () {
          _this5.addSearchResultsClickOutsideListener();
        }, 500);
      });
    },
    // 加载腾讯地图API
    loadTencentMapAPI: function loadTencentMapAPI() {
      var _this6 = this;
      // 检查是否已经加载了腾讯地图API
      if (typeof TMap !== 'undefined') {
        // 延迟初始化，确保API完全加载
        setTimeout(function () {
          _this6.initTencentMap();
        }, 500);
        return;
      }

      // 动态加载腾讯地图API
      var script = document.createElement('script');
      script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=' + process.env.VUE_APP_TENCENT_MAP_KEY;
      script.onload = function () {
        console.log('腾讯地图API加载完成');
        // 延迟初始化，确保API完全加载
        setTimeout(function () {
          _this6.initTencentMap();
        }, 1000);
      };
      script.onerror = function () {
        console.error('腾讯地图API加载失败');
        _this6.$message.error('地图API加载失败，请检查网络连接');
      };
      document.head.appendChild(script);
    },
    // 添加点击外部隐藏搜索结果的事件监听
    addSearchResultsClickOutsideListener: function addSearchResultsClickOutsideListener() {
      document.addEventListener('click', this.handleClickOutside);
    },
    // 移除点击外部隐藏搜索结果的事件监听
    removeSearchResultsClickOutsideListener: function removeSearchResultsClickOutsideListener() {
      document.removeEventListener('click', this.handleClickOutside);
    },
    // 处理点击外部区域
    handleClickOutside: function handleClickOutside(event) {
      var searchSection = document.querySelector('.search-section');
      if (searchSection && !searchSection.contains(event.target)) {
        this.showSearchResults = false;
      }
    },
    // 处理地图Dialog关闭
    handleMapDialogClose: function handleMapDialogClose() {
      this.mapDialogVisible = false;
      this.removeSearchResultsClickOutsideListener();
      // 只清理临时数据，不销毁地图实例
      this.clearTempMapData();
    },
    // 确认位置选择
    confirmLocation: function confirmLocation() {
      if (this.reverseGeocodeLoading) {
        this.$message.info('地址解析中，请稍候');
        return;
      }
      if (this.selectionNeedsGeocode) {
        this.$message.warning('该位置的行政区信息尚未获取，请重新选择位置');
        return;
      }
      if (this.selectedAddress) {
        // 地图选择的内容直接填写到详细地址输入框中
        this.form.detail = this.selectedAddress;
        this.form.longitude = this.selectedLng;
        this.form.latitude = this.selectedLat;

        // 更新省市区信息
        if (this.selectedAddressDetail && this.selectedAddressDetail.addressComponent) {
          var comp = this.selectedAddressDetail.addressComponent;
          var regionIds = resolveMapRegionIds(this.selectedAddressDetail);
          console.log('comp', comp);
          this.form.province = comp.province || '';
          this.form.city = comp.city || '';
          this.form.district = comp.district || comp.county || '';
          this.form.provinceId = regionIds.provinceId;
          this.form.cityId = regionIds.cityId;
          this.form.districtId = regionIds.districtId;
          this.syncRegionSelectionFromForm();
          // 更新显示文本
          this.updateRegionDisplayText();
        }
        this.mapDialogVisible = false;
        this.clearTempSelection();
      } else {
        this.$message.warning('请先在地图上选择位置');
      }
    },
    // 初始化腾讯地图
    initTencentMap: function initTencentMap() {
      try {
        // 检查腾讯地图API是否加载
        if (typeof TMap === 'undefined') {
          console.error('腾讯地图API未加载');
          this.$message.error('腾讯地图API未加载，请检查网络连接或刷新页面重试');
          return;
        }
        console.log('TMap对象:', TMap);
        console.log('TMap.Map:', TMap.Map);

        // 检查地图实例是否已存在
        if (this.tencentMap) {
          // 清理标记点
          if (this.tencentMarker) {
            this.tencentMarker.setMap(null);
            this.tencentMarker = null;
          }
        } else {
          // 创建全新的地图实例
          this.tencentMap = new TMap.Map('tencentMapContainer', {
            center: new TMap.LatLng(39.9042, 116.4074),
            // 默认北京
            zoom: 10
          });
        }

        // 设置地图中心点和缩放级别
        // 如果有已选择的位置，定位到该位置；否则使用默认位置
        if (this.form.longitude && this.form.latitude) {
          var lng = parseFloat(this.form.longitude);
          var lat = parseFloat(this.form.latitude);
          this.tencentMap.setCenter(new TMap.LatLng(lat, lng));
          this.tencentMap.setZoom(15);

          // 恢复已选择的位置信息
          this.selectedLng = this.form.longitude;
          this.selectedLat = this.form.latitude;
          this.selectedAddress = this.form.detail;

          // 添加标记
          this.addMarker(lng, lat);

          // 获取城市信息
          this.getCurrentCity(lng, lat);
        } else {
          this.tencentMap.setCenter(new TMap.LatLng(39.9042, 116.4074)); // 默认北京
          this.tencentMap.setZoom(10);
        }

        // 只有在没有已选择位置时才进行定位
        if (!this.form.longitude || !this.form.latitude) {
          this.locateCurrentPosition();
        }

        // 绑定地图事件（避免重复绑定）
        this.bindMapEvents();
        console.log('腾讯地图初始化成功');
      } catch (error) {
        console.error('腾讯地图初始化失败:', error);
        console.error('错误详情:', error.stack);
        this.$message.error('地图初始化失败: ' + error.message + '，请重试或选择手动输入地址');
      }
    },
    // 获取当前城市信息
    getCurrentCity: function getCurrentCity(lng, lat) {
      var _this7 = this;
      // 使用腾讯地图WebService API进行逆地理编码，使用JSONP解决跨域问题
      var apiUrl = 'https://apis.map.qq.com/ws/geocoder/v1/';
      var params = new URLSearchParams({
        location: "".concat(lat, ",").concat(lng),
        key: process.env.VUE_APP_TENCENT_MAP_KEY,
        get_poi: '0',
        output: 'jsonp'
      });

      // 生成唯一的回调函数名
      var callbackName = "qqMapCallback_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));

      // 在参数中添加callback
      params.append('callback', callbackName);

      // 调试：打印完整的请求URL
      var fullUrl = "".concat(apiUrl, "?").concat(params.toString());
      console.log('getCurrentCity JSONP请求URL:', fullUrl);
      console.log('请求参数:', Object.fromEntries(params));

      // 创建全局回调函数
      window[callbackName] = function (data) {
        try {
          if (data.status === 0 && data.result && data.result.address_component) {
            var addressComponent = data.result.address_component;
            _this7.currentCity = addressComponent.city || addressComponent.province || '北京';
            _this7.currentCityCode = addressComponent.city_code || addressComponent.adcode || '110000000';
          } else {
            _this7.currentCity = '北京'; // 默认城市
            _this7.currentCityCode = '110000000';
          }
        } catch (error) {
          console.error('解析城市信息失败:', error);
          _this7.currentCity = '北京'; // 默认城市
          _this7.currentCityCode = '110000000';
        } finally {
          // 清理回调函数和script标签
          _this7.cleanupJsonp(callbackName);
        }
      };

      // 创建script标签进行JSONP请求
      var script = document.createElement('script');
      script.src = "".concat(apiUrl, "?").concat(params.toString());
      script.onerror = function () {
        console.error('获取城市信息失败: 网络错误');
        _this7.currentCity = '北京'; // 默认城市
        _this7.currentCityCode = '110000000';
        _this7.cleanupJsonp(callbackName);
      };

      // 设置超时处理
      setTimeout(function () {
        if (window[callbackName]) {
          console.error('获取城市信息超时');
          _this7.currentCity = '北京'; // 默认城市
          _this7.currentCityCode = '110000000';
          _this7.cleanupJsonp(callbackName);
        }
      }, 10000); // 10秒超时

      document.head.appendChild(script);
    },
    // 清理JSONP请求
    cleanupJsonp: function cleanupJsonp(callbackName) {
      // 删除全局回调函数
      if (window[callbackName]) {
        delete window[callbackName];
      }

      // 删除script标签
      var scripts = document.querySelectorAll("script[src*=\"".concat(callbackName, "\"]"));
      scripts.forEach(function (script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    },
    // 绑定地图事件
    bindMapEvents: function bindMapEvents() {
      var _this8 = this;
      if (!this.tencentMap) {
        console.warn('地图实例不存在，无法绑定事件');
        return;
      }

      // 只在首次创建时绑定事件，避免重复绑定
      if (!this.mapEventsBound) {
        // 地图点击事件 - 支持点击切换选中点
        this.tencentMap.on('click', function (e) {
          _this8.onMapClick(e);
        });

        // 地图移动事件 - 清空搜索结果
        this.tencentMap.on('moveend', function () {
          _this8.clearSearchResults();
        });

        // 地图缩放事件 - 清空搜索结果
        this.tencentMap.on('zoomend', function () {
          _this8.clearSearchResults();
        });
        this.mapEventsBound = true;
      }
    },
    // 地图点击事件处理
    onMapClick: function onMapClick(e) {
      console.log('点击事件对象:', e);
      var lng, lat;

      // 根据实际的事件结构获取坐标
      if (e.latLng && e.latLng.lng !== undefined && e.latLng.lat !== undefined) {
        lng = e.latLng.lng;
        lat = e.latLng.lat;
      } else if (e.lnglat && e.lnglat.lng !== undefined && e.lnglat.lat !== undefined) {
        lng = e.lnglat.lng;
        lat = e.lnglat.lat;
      } else if (e.lng !== undefined && e.lat !== undefined) {
        lng = e.lng;
        lat = e.lat;
      } else if (e.lnglat && typeof e.lnglat.getLng === 'function') {
        lng = e.lnglat.getLng();
        lat = e.lnglat.getLat();
      } else if (e.lnglat && e.lnglat.lnglat) {
        lng = e.lnglat.lnglat.lng;
        lat = e.lnglat.lnglat.lat;
      } else {
        console.error('无法获取点击坐标:', e);
        this.$message.error('无法获取点击位置坐标');
        return;
      }
      console.log('地图点击位置:', lng, lat);

      // 如果有POI信息，优先使用POI的坐标
      if (e.poi && e.poi.latLng) {
        lng = e.poi.latLng.lng;
        lat = e.poi.latLng.lat;
        console.log('点击了POI:', e.poi.name, '坐标:', lng, lat);
      }

      // 清空搜索结果
      this.clearSearchResults();

      // 更新选择的位置
      this.selectedLng = lng.toFixed(6);
      this.selectedLat = lat.toFixed(6);
      this.selectedLocationName = '';
      this.selectedAddressDetail = null;

      // 逆地理编码获取地址
      this.reverseGeocode(lng, lat);

      // 添加标记点 - 点击切换选中点
      this.addMarker(lng, lat);
      console.log('已选择新位置:', this.selectedLng, this.selectedLat);
    },
    // 逆地理编码 - 获取详细地址信息
    reverseGeocode: function reverseGeocode(lng, lat) {
      var _this9 = this;
      var requestId = ++this.reverseGeocodeRequestId;
      this.reverseGeocodeLoading = true;
      this.selectionNeedsGeocode = true;
      this.selectedAddressDetail = null;
      // 使用腾讯地图WebService API进行逆地理编码，使用JSONP解决跨域问题
      var apiUrl = 'https://apis.map.qq.com/ws/geocoder/v1/';
      var params = new URLSearchParams({
        location: "".concat(lat, ",").concat(lng),
        key: process.env.VUE_APP_TENCENT_MAP_KEY,
        get_poi: '1',
        output: 'jsonp'
      });

      // 生成唯一的回调函数名
      var callbackName = "qqMapReverseCallback_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));

      // 在参数中添加callback
      params.append('callback', callbackName);

      // 调试：打印完整的请求URL
      var fullUrl = "".concat(apiUrl, "?").concat(params.toString());
      console.log('reverseGeocode JSONP请求URL:', fullUrl);
      console.log('请求参数:', Object.fromEntries(params));

      // 创建全局回调函数
      window[callbackName] = function (data) {
        try {
          if (requestId !== _this9.reverseGeocodeRequestId) return;
          if (data.status === 0 && data.result) {
            var resultData = data.result;
            var address = '';

            // 构建详细地址信息
            if (resultData.formatted_addresses) {
              address = resultData.formatted_addresses.standard_address + (resultData.formatted_addresses.recommend || resultData.formatted_addresses.rough);
            } else if (resultData.address) {
              address = resultData.address;
            } else {
              // 手动构建地址
              var addressComponents = [];
              if (resultData.address_component) {
                var comp = resultData.address_component;
                if (comp.province) addressComponents.push(comp.province);
                if (comp.city) addressComponents.push(comp.city);
                if (comp.district) addressComponents.push(comp.district);
                if (comp.street) addressComponents.push(comp.street);
                if (comp.street_number) addressComponents.push(comp.street_number);
              }
              address = addressComponents.length > 0 ? addressComponents.join('') : "\u5750\u6807\u4F4D\u7F6E (".concat(lng.toFixed(6), ", ").concat(lat.toFixed(6), ")");
            }
            _this9.selectedAddress = address;
            _this9.selectedLng = lng.toFixed(6);
            _this9.selectedLat = lat.toFixed(6);
            console.log('逆地理编码结果:', resultData);

            // 存储详细地址信息用于显示
            _this9.selectedAddressDetail = {
              formatted_address: resultData.formatted_addresses ? resultData.formatted_addresses.recommend : address,
              address: resultData.address || '',
              addressComponent: resultData.address_component || {},
              business: resultData.business || '',
              citycode: resultData.address_component ? resultData.address_component.city_code : '',
              adcode: resultData.address_component ? resultData.address_component.adcode : ''
            };
            _this9.selectionNeedsGeocode = false;
          } else {
            _this9.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(lng.toFixed(6), ", ").concat(lat.toFixed(6), ")");
            _this9.selectedLng = lng.toFixed(6);
            _this9.selectedLat = lat.toFixed(6);
            _this9.selectedLocationName = '';
            _this9.selectedAddressDetail = null;
            console.warn('逆地理编码失败:', data);
          }
        } catch (error) {
          if (requestId !== _this9.reverseGeocodeRequestId) return;
          console.error('解析逆地理编码数据失败:', error);
          _this9.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(lng.toFixed(6), ", ").concat(lat.toFixed(6), ")");
          _this9.selectedLng = lng.toFixed(6);
          _this9.selectedLat = lat.toFixed(6);
          _this9.selectedLocationName = '';
          _this9.selectedAddressDetail = null;
        } finally {
          if (requestId === _this9.reverseGeocodeRequestId) _this9.reverseGeocodeLoading = false;
          // 清理回调函数和script标签
          _this9.cleanupJsonp(callbackName);
        }
      };

      // 创建script标签进行JSONP请求
      var script = document.createElement('script');
      script.src = "".concat(apiUrl, "?").concat(params.toString());
      script.onerror = function () {
        if (requestId !== _this9.reverseGeocodeRequestId) {
          _this9.cleanupJsonp(callbackName);
          return;
        }
        console.error('逆地理编码请求失败: 网络错误');
        _this9.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(lng.toFixed(6), ", ").concat(lat.toFixed(6), ")");
        _this9.selectedLng = lng.toFixed(6);
        _this9.selectedLat = lat.toFixed(6);
        _this9.selectedLocationName = '';
        _this9.selectedAddressDetail = null;
        _this9.reverseGeocodeLoading = false;
        _this9.cleanupJsonp(callbackName);
      };

      // 设置超时处理
      setTimeout(function () {
        if (window[callbackName]) {
          if (requestId !== _this9.reverseGeocodeRequestId) {
            _this9.cleanupJsonp(callbackName);
            return;
          }
          console.error('逆地理编码请求超时');
          _this9.selectedAddress = "\u5750\u6807\u4F4D\u7F6E (".concat(lng.toFixed(6), ", ").concat(lat.toFixed(6), ")");
          _this9.selectedLng = lng.toFixed(6);
          _this9.selectedLat = lat.toFixed(6);
          _this9.selectedLocationName = '';
          _this9.selectedAddressDetail = null;
          _this9.reverseGeocodeLoading = false;
          _this9.cleanupJsonp(callbackName);
        }
      }, 10000); // 10秒超时

      document.head.appendChild(script);
    },
    // 添加标记点
    addMarker: function addMarker(lng, lat) {
      var _this0 = this;
      this.$nextTick(function () {
        // 移除之前的标记
        if (_this0.tencentMarker) {
          _this0.tencentMarker.setMap(null);
        }

        // 创建新标记 - 使用腾讯地图的标准标记
        _this0.tencentMarker = new TMap.MultiMarker({
          map: _this0.tencentMap,
          geometries: [{
            id: 'marker',
            position: new TMap.LatLng(lat, lng),
            // 使用腾讯地图内置的标记样式
            styleId: 'marker'
          }]
        });
      });
    },
    // 搜索输入处理
    onSearchInput: function onSearchInput() {
      // 隐藏搜索结果
      this.showSearchResults = false;
      this.searchResults = [];
    },
    // 清空搜索结果
    clearSearchResults: function clearSearchResults() {
      this.showSearchResults = false;
      this.searchResults = [];
      this.searchKeyword = '';
      this.currentSearchKeyword = ''; // 清空搜索关键词
    },
    // 关键字搜索 - 使用腾讯地图API搜索
    searchLocation: function searchLocation(query) {
      if (!query || !query.trim()) {
        this.searchRequestId++;
        this.searchLoading = false;
        this.searchResults = [];
        this.searchNoDataText = '请输入地点名称搜索';
        this.currentSearchKeyword = '';
        return;
      }

      // 保存当前搜索关键词
      this.currentSearchKeyword = query.trim();
      if (this.searchScope === 'city' && !this.specifiedSearchCity) {
        this.searchResults = [];
        this.searchNoDataText = '请选择目标城市后搜索';
        return;
      }
      this.searchLoading = true;
      this.searchNoDataText = '搜索中...';

      // 重置分页状态
      this.currentPage = 1;
      this.searchResults = [];
      this.hasMoreResults = false;

      // 执行搜索
      this.performSearch(query);
    },
    // 执行搜索
    performSearch: function performSearch(query) {
      var _this1 = this;
      // 使用腾讯地图WebService API进行地点搜索，使用JSONP解决跨域问题
      var apiUrl = 'https://apis.map.qq.com/ws/place/v1/search';
      var params = new URLSearchParams({
        keyword: query,
        page_size: this.pageSize.toString(),
        page_index: this.currentPage.toString(),
        key: process.env.VUE_APP_TENCENT_MAP_KEY,
        output: 'jsonp'
      });
      var boundaryCity = this.searchScope === 'city' ? this.specifiedSearchCity : this.searchScope === 'current' ? this.currentCity || this.form.city || this.form.province || '北京' : '';
      if (boundaryCity) {
        params.append('boundary', "region(".concat(boundaryCity, ",0)"));
      }
      var requestId = ++this.searchRequestId;

      // 生成唯一的回调函数名
      var callbackName = "qqMapSearchCallback_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));

      // 在参数中添加callback
      params.append('callback', callbackName);

      // 调试：打印完整的请求URL
      var fullUrl = "".concat(apiUrl, "?").concat(params.toString());
      console.log('performSearch JSONP请求URL:', fullUrl);
      console.log('搜索参数:', Object.fromEntries(params));

      // 创建全局回调函数
      window[callbackName] = function (data) {
        try {
          if (requestId !== _this1.searchRequestId) return;
          _this1.handleSearchAPIResponse(data);
        } catch (error) {
          console.error('解析搜索数据失败:', error);
          _this1.searchLoading = false;
          _this1.searchNoDataText = '搜索失败，请重试';
          _this1.$message.error('搜索失败，请重试');
        } finally {
          // 清理回调函数和script标签
          _this1.cleanupJsonp(callbackName);
        }
      };

      // 创建script标签进行JSONP请求
      var script = document.createElement('script');
      script.src = "".concat(apiUrl, "?").concat(params.toString());
      script.onerror = function () {
        console.error('搜索API调用失败: 网络错误');
        _this1.searchLoading = false;
        _this1.searchNoDataText = '搜索失败，请重试';
        _this1.$message.error('搜索失败，请重试');
        _this1.cleanupJsonp(callbackName);
      };

      // 设置超时处理
      setTimeout(function () {
        if (window[callbackName]) {
          console.error('搜索请求超时');
          _this1.searchLoading = false;
          _this1.searchNoDataText = '搜索超时，请重试';
          _this1.$message.error('搜索超时，请重试');
          _this1.cleanupJsonp(callbackName);
        }
      }, 10000); // 10秒超时

      document.head.appendChild(script);
    },
    // 加载更多搜索结果
    loadMoreResults: function loadMoreResults() {
      if (this.loadingMore || !this.hasMoreResults) {
        return;
      }

      // 检查是否有搜索关键词
      if (!this.currentSearchKeyword) {
        this.$message.warning('请先进行搜索');
        return;
      }
      this.loadingMore = true;
      this.currentPage++;

      // 使用保存的搜索关键词
      this.performSearch(this.currentSearchKeyword);
    },
    // 处理搜索API响应
    handleSearchAPIResponse: function handleSearchAPIResponse(data) {
      console.log('搜索API响应:', data);
      this.loadingMore = false;
      this.searchLoading = false;
      var pois = [];
      if (data && data.status === 0 && data.data && data.data) {
        pois = data.data;
      } else if (data && data.data) {
        pois = data.data;
      } else {
        pois = [];
      }
      if (pois && pois.length > 0) {
        var newResults = pois.map(function (poi) {
          return {
            name: poi.title || poi.name,
            address: poi.address,
            city: poi.ad_info && (poi.ad_info.city || poi.ad_info.province) || '',
            lng: poi.location ? poi.location.lng : 0,
            lat: poi.location ? poi.location.lat : 0
          };
        });

        // 如果是第一页，替换结果；否则追加结果
        if (this.currentPage === 1) {
          this.searchResults = newResults;
        } else {
          this.searchResults = this.searchResults.concat(newResults);
        }

        // 判断是否还有更多结果
        this.hasMoreResults = pois.length === this.pageSize;

        // 更新无数据文本
        this.searchNoDataText = '暂无更多数据';
      } else {
        // 如果是第一页且无结果，显示无结果提示
        if (this.currentPage === 1) {
          this.searchResults = [];
          this.searchNoDataText = '未找到相关地点，请尝试其他关键词';
        }
        this.hasMoreResults = false;
      }
    },
    // 处理搜索结果选择变化
    handleSearchResultChange: function handleSearchResultChange(result) {
      if (result && result.lng && result.lat) {
        this.selectSearchResult(result);
      }
    },
    // 处理下拉框显示状态变化
    handleSelectVisibleChange: function handleSelectVisibleChange(visible) {
      if (!visible) {
        // 下拉框关闭时清空选择
        this.selectedSearchResult = null;
        // 如果当前没有搜索关键词，清空搜索结果
        if (!this.currentSearchKeyword) {
          this.searchResults = [];
        }
      }
    },
    // 选择搜索结果
    selectSearchResult: function selectSearchResult(result) {
      // 隐藏搜索结果下拉
      this.showSearchResults = false;

      // 移动到搜索结果位置
      this.tencentMap.setCenter(new TMap.LatLng(result.lat, result.lng));
      this.tencentMap.setZoom(15);

      // 设置地址信息
      this.selectedLocationName = result.name;
      this.selectedAddress = result.address || result.name;
      this.selectedAddressDetail = null;
      this.selectedLng = result.lng.toFixed(6);
      this.selectedLat = result.lat.toFixed(6);

      // 添加标记并设置地址
      this.addMarker(result.lng, result.lat);

      // 获取详细地址信息
      this.reverseGeocode(result.lng, result.lat);
    },
    // 处理搜索结果列表滚轮事件
    handleSearchResultsWheel: function handleSearchResultsWheel(event) {
      // 阻止事件冒泡到地图，防止地图缩放
      event.stopPropagation();
      event.preventDefault();

      // 手动处理滚动
      var container = event.currentTarget;
      var scrollTop = container.scrollTop;
      var scrollHeight = container.scrollHeight;
      var clientHeight = container.clientHeight;

      // 计算滚动距离
      var delta = event.deltaY || event.deltaWheelDelta || 0;
      var scrollStep = 30; // 每次滚动的像素数

      if (delta > 0) {
        // 向下滚动
        container.scrollTop = Math.min(scrollTop + scrollStep, scrollHeight - clientHeight);
      } else {
        // 向上滚动
        container.scrollTop = Math.max(scrollTop - scrollStep, 0);
      }
    },
    // 处理搜索结果列表触摸事件
    handleSearchResultsTouch: function handleSearchResultsTouch(event) {
      // 阻止触摸事件冒泡到地图
      event.stopPropagation();
    },
    // 处理定位按钮点击
    handleLocationClick: function handleLocationClick(event) {
      console.log('定位按钮点击事件触发！', event);
      event.preventDefault();
      event.stopPropagation();
      this.locateCurrentPosition();
    },
    // 定位到当前位置
    locateCurrentPosition: function locateCurrentPosition(event) {
      var _this10 = this;
      console.log('定位按钮被点击了！', event);
      // 阻止事件冒泡
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      // 清空搜索结果
      this.clearSearchResults();
      if (!this.tencentMap) {
        this.$message.warning('地图未初始化');
        return;
      }

      // 检查腾讯地图定位组件是否可用
      if (!window.LBS || !window.LBS.WebComponent || !window.LBS.WebComponent.Geolocation) {
        this.$message.warning('腾讯地图定位组件未加载');
        return;
      }

      // 只初始化一次定位实例
      if (!this.geolocationInstance) {
        this.geolocationInstance = new window.LBS.WebComponent.Geolocation({
          key: process.env.VUE_APP_TENCENT_MAP_KEY,
          referer: process.env.VUE_APP_TENCENT_MAP_REFERER
        });
      }

      // 显示定位中提示
      this.$message.info('正在定位中...');

      // 定位成功回调
      var onSuccess = function onSuccess(result) {
        var lng = result.lng;
        var lat = result.lat;

        // 移动到当前位置
        _this10.tencentMap.setCenter(new TMap.LatLng(lat, lng));
        _this10.tencentMap.setZoom(15);

        // 更新选择的位置
        _this10.selectedLng = lng.toFixed(6);
        _this10.selectedLat = lat.toFixed(6);

        // 添加标记并获取地址
        _this10.addMarker(lng, lat);

        // 获取地址和城市信息
        _this10.reverseGeocode(lng, lat);
        _this10.getCurrentCity(lng, lat);
        _this10.$message.success('定位成功');
      };

      // 定位失败回调
      var onError = function onError(error) {
        console.error('定位失败:', error);
        _this10.$message.warning('定位失败：' + (error.message || '未知错误'));
        // 使用默认位置（北京）
        _this10.tencentMap.setCenter(new TMap.LatLng(39.9042, 116.4074));
        _this10.tencentMap.setZoom(10);
        _this10.currentCity = '北京';
        _this10.currentCityCode = '110000000';
      };

      // 调用腾讯地图定位方法（使用回调而不是 await）
      this.geolocationInstance.getLocation(onSuccess, onError, {
        timeout: 10000,
        highAccuracy: true,
        maximumAge: 60000
      });
    },
    // 清理临时地图数据（不销毁地图实例）
    clearTempMapData: function clearTempMapData() {
      this.reverseGeocodeRequestId++;
      this.reverseGeocodeLoading = false;
      this.selectionNeedsGeocode = false;
      // 清理地图选择数据
      this.searchKeyword = '';
      this.searchResults = [];
      this.showSearchResults = false;
      this.selectedAddress = '';
      this.selectedLocationName = '';
      this.selectedLng = '';
      this.selectedLat = '';
      this.selectedAddressDetail = null;
      // 注意：不清除currentCity，保持城市信息用于下次搜索

      // 清理地图覆盖物，但保留地图实例
      if (this.tencentMap) {
        try {
          // 清理标记点
          if (this.tencentMarker) {
            this.tencentMarker.setMap(null);
            this.tencentMarker = null;
          }
        } catch (e) {
          console.warn('清理地图覆盖物时出错:', e);
        }
      }

      // 清理标记引用
      this.tencentMarker = null;
    },
    // 清理临时选择数据（不清理已确认的位置）
    clearTempSelection: function clearTempSelection() {
      this.reverseGeocodeRequestId++;
      this.reverseGeocodeLoading = false;
      this.selectionNeedsGeocode = false;
      this.searchKeyword = '';
      this.searchResults = [];
      this.showSearchResults = false;
      this.selectedLocationName = '';
      this.selectedAddressDetail = null;
    },
    // 获取当前步骤需要验证的字段
    getCurrentStepFields: function getCurrentStepFields() {
      var stepFields = {
        '1': ['marketName', 'marketType', 'environmentType', 'siteType', 'regionCode', 'detail'],
        // 基础信息
        '2': [],
        // 摊位信息 - 摊位设置和摊位分布图都改为非必填
        '3': ['facilities', 'marketImgs', 'marketInfo', 'contactPerson', 'contactPhone'] // 详细信息
      };
      return stepFields[this.currentTab] || [];
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 保存并填写下一步
    handleSaveAndNext: function handleSaveAndNext(formName) {
      var _this11 = this;
      // 根据当前步骤验证对应的字段
      var currentStepFields = this.getCurrentStepFields();
      if (currentStepFields.length === 0) {
        // 如果没有必填字段，直接保存并跳转
        this.saveCurrentStepAndNext();
        return;
      }

      // 使用Promise处理异步验证
      var validatePromises = currentStepFields.map(function (field) {
        return new Promise(function (resolve) {
          _this11.$refs[formName].validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validatePromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (!hasError) {
          // 验证通过，保存数据并跳转到下一步
          _this11.saveCurrentStepAndNext();
        } else {
          _this11.$message.warning('请填写完整信息！');
        }
      });
    },
    // 保存当前步骤
    handleSaveCurrentStep: function handleSaveCurrentStep(formName) {
      var _this12 = this;
      // 根据当前步骤验证对应的字段
      var currentStepFields = this.getCurrentStepFields();
      if (currentStepFields.length === 0) {
        // 如果没有必填字段，直接保存
        this.saveCurrentStep();
        return;
      }

      // 使用Promise处理异步验证
      var validatePromises = currentStepFields.map(function (field) {
        return new Promise(function (resolve) {
          _this12.$refs[formName].validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validatePromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (!hasError) {
          _this12.saveCurrentStep();
        } else {
          _this12.$message.warning('请填写完整信息！');
        }
      });
    },
    // 保存当前步骤数据并跳转到下一步
    saveCurrentStepAndNext: function saveCurrentStepAndNext() {
      var _this13 = this;
      // 防止重复保存
      if (this.saveStepLoading) {
        return;
      }
      this.saveStepLoading = true;
      this.form.marketSupporting = this.form.facilities.join(',');
      this.form.marketLayoutImg = JSON.stringify(this.form.marketLayoutImgs);
      this.form.marketImg = JSON.stringify(this.form.marketImgs);

      // 处理摊位设置数据，确保包含所有数据（包括标记为删除的数据）
      var processedMarketAreaList = this.form.marketAreaList.map(function (area) {
        return {
          id: area.id,
          areaName: area.areaName,
          areaRemark: area.areaRemark,
          isDel: area.isDel || false,
          marketStallList: area.marketStallList.map(function (stall) {
            return {
              id: stall.id,
              areaId: stall.areaId,
              stallName: stall.stallName,
              stallRemark: stall.stallRemark,
              stallNum: stall.stallNum,
              isDel: stall.isDel || false
            };
          })
        };
      });
      var submitData = _objectSpread(_objectSpread({}, this.form), {}, {
        marketAreaList: processedMarketAreaList
      });

      // 如果是新增，使用marketSave；如果是编辑，使用marketUpdate
      var submitMethod = this.isEdit ? _market.marketUpdate : _market.marketSave;
      console.log(submitData, 'submitData');
      submitMethod(submitData).then(function (res) {
        _this13.saveStepLoading = false;
        _this13.$message.success('当前步骤保存成功');

        // 如果是新增，保存成功后获取ID并设置为编辑模式
        // 注意：拦截器返回的是res.data，所以res就是数据本身
        if (!_this13.isEdit && res) {
          _this13.form.id = res;
          _this13.isEdit = true;
        }

        // 保存成功后重新加载数据并回显
        var idToLoad = _this13.isEdit ? _this13.form.id : res;
        if (idToLoad) {
          _this13.loadMarketInfo(idToLoad);
        }

        // 保存成功后跳转到下一步
        _this13.currentTab = (Number(_this13.currentTab) + 1).toString();
      }).catch(function (error) {
        _this13.saveStepLoading = false;
        // 移除重复的错误提示，因为request拦截器已经显示了
      });
    },
    // 保存当前步骤数据
    saveCurrentStep: function saveCurrentStep() {
      var _this14 = this;
      // 防止重复保存
      if (this.saveStepLoading) {
        return;
      }
      this.saveStepLoading = true;
      this.form.marketSupporting = this.form.facilities.join(',');
      this.form.marketLayoutImg = JSON.stringify(this.form.marketLayoutImgs);
      this.form.marketImg = JSON.stringify(this.form.marketImgs);

      // 处理摊位设置数据，确保包含所有数据（包括标记为删除的数据）
      var processedMarketAreaList = this.form.marketAreaList.map(function (area) {
        return {
          id: area.id,
          areaName: area.areaName,
          areaRemark: area.areaRemark,
          isDel: area.isDel || false,
          marketStallList: area.marketStallList.map(function (stall) {
            return {
              id: stall.id,
              areaId: stall.areaId,
              stallName: stall.stallName,
              stallRemark: stall.stallRemark,
              stallNum: stall.stallNum,
              isDel: stall.isDel || false
            };
          })
        };
      });
      var submitData = _objectSpread(_objectSpread({}, this.form), {}, {
        marketAreaList: processedMarketAreaList
      });

      // 如果是新增，使用marketSave；如果是编辑，使用marketUpdate
      var submitMethod = this.isEdit ? _market.marketUpdate : _market.marketSave;
      console.log(submitData, 'submitData1');
      submitMethod(submitData).then(function (res) {
        _this14.saveStepLoading = false;
        _this14.$message.success('当前步骤保存成功');

        // 如果是新增，保存成功后获取ID并设置为编辑模式
        if (!_this14.isEdit && res) {
          _this14.form.id = res;
          _this14.isEdit = true;
        }

        // 保存成功后重新加载数据并回显
        var idToLoad = _this14.isEdit ? _this14.form.id : res;
        if (idToLoad) {
          _this14.loadMarketInfo(idToLoad);
        }
      }).catch(function () {
        _this14.saveStepLoading = false;
        // 移除重复的错误提示，因为request拦截器已经显示了
      });
    },
    // 提交表单（最后一步）
    handleSubmit: function handleSubmit(formName) {
      var _this15 = this;
      // 根据当前步骤验证对应的字段
      var currentStepFields = this.getCurrentStepFields();
      if (currentStepFields.length === 0) {
        // 如果没有必填字段，直接保存
        this.saveFinalStep();
        return;
      }

      // 使用Promise处理异步验证
      var validatePromises = currentStepFields.map(function (field) {
        return new Promise(function (resolve) {
          _this15.$refs[formName].validateField(field, function (errorMessage) {
            resolve({
              field: field,
              errorMessage: errorMessage
            });
          });
        });
      });
      Promise.all(validatePromises).then(function (results) {
        var hasError = results.some(function (result) {
          return result.errorMessage;
        });
        if (!hasError) {
          _this15.saveFinalStep();
        } else {
          _this15.$message.warning('请填写完整信息！');
        }
      });
    },
    // 保存最后一步
    saveFinalStep: function saveFinalStep() {
      var _this16 = this;
      // 防止重复提交
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      this.form.marketSupporting = this.form.facilities.join(',');
      this.form.marketLayoutImg = JSON.stringify(this.form.marketLayoutImgs);
      this.form.marketImg = JSON.stringify(this.form.marketImgs);

      // 处理摊位设置数据，确保包含所有数据（包括标记为删除的数据）
      var processedMarketAreaList = this.form.marketAreaList.map(function (area) {
        return {
          id: area.id,
          areaName: area.areaName,
          areaRemark: area.areaRemark,
          isDel: area.isDel || false,
          marketStallList: area.marketStallList.map(function (stall) {
            return {
              id: stall.id,
              areaId: stall.areaId,
              stallName: stall.stallName,
              stallRemark: stall.stallRemark,
              stallNum: stall.stallNum,
              isDel: stall.isDel || false
            };
          })
        };
      });
      var submitData = _objectSpread(_objectSpread({}, this.form), {}, {
        marketAreaList: processedMarketAreaList
      });
      if (!this.form.id) {
        (0, _market.marketSave)(submitData).then(function (res) {
          _this16.submitLoading = false;
          _this16.$message.success('集市信息保存成功');
          // this.closeSelectedTag()
          _this16.$router.push({
            path: '/market/list'
          });
          // this.goBack();
          // this.closeSelectedTag()
          // setTimeout(() => {
          //   this.$router.push({ path: '/market/list' })
          // }, 1000)
        }).catch(function () {
          _this16.submitLoading = false;
        });
      } else {
        // 最后一步使用更新接口
        (0, _market.marketUpdate)(submitData).then(function () {
          _this16.submitLoading = false;
          _this16.$message.success('集市信息保存成功');
          _this16.$router.push({
            path: '/market/list'
          });
          // this.closeSelectedTag()
          // this.goBack();

          // setTimeout(() => {
          //   this.$router.push({ path: '/market/list' })
          // }, 1000)
        }).catch(function () {
          _this16.submitLoading = false;
          // 移除重复的错误提示，因为request拦截器已经显示了
        });
      }
    },
    // 取消操作
    handleCancel: function handleCancel() {
      this.$router.push({
        path: '/market/list'
      });
    },
    // 图片上传
    modalPicTap: function modalPicTap(field) {
      if (this.isDisabled) return;
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.form[field] = img[0].sattDir;
      }, field, 'selfUpload');
    },
    // 删除图片
    handleRemoveImg: function handleRemoveImg(field) {
      this.form[field] = '';
    },
    // 摊位设置相关方法
    // 添加区域
    addArea: function addArea() {
      this.form.marketAreaList.push({
        id: null,
        // 新区域没有ID
        areaName: '',
        areaRemark: '',
        isDel: false,
        // 默认未删除
        marketStallList: [],
        merId: this.form.merId
      });
    },
    // 删除区域
    removeArea: function removeArea(visibleIndex) {
      var _this17 = this;
      // 找到在原始数组中的实际索引
      var actualIndex = this.form.marketAreaList.findIndex(function (area) {
        return !area.isDel && area === _this17.visibleAreas[visibleIndex];
      });
      var area = this.form.marketAreaList[actualIndex];
      var areaName = area.areaName || "\u533A\u57DF".concat(visibleIndex + 1);
      var stallCount = area.marketStallList ? area.marketStallList.length : 0;
      this.$modal.confirm("\u786E\u8BA4\u5220\u9664\"".concat(areaName, "\"\u5417\uFF1F").concat(stallCount > 0 ? "\u8BE5\u533A\u57DF\u5305\u542B".concat(stallCount, "\u4E2A\u4F4D\u7F6E\uFF0C\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\uFF01") : '删除后不可恢复！')).then(function () {
        // 如果区域有ID，设置isDel为true；否则直接从数组中移除
        if (area.id) {
          area.isDel = true;
          // 同时标记该区域下的所有位置为删除状态
          if (area.marketStallList) {
            area.marketStallList.forEach(function (stall) {
              stall.isDel = true;
            });
          }
          _this17.$message.success('区域已标记为删除');
        } else {
          // 新添加的区域没有ID，直接从数组中移除
          _this17.form.marketAreaList.splice(actualIndex, 1);
          // 删除区域后，重新计算所有区域的摊位编号
          _this17.form.marketAreaList.forEach(function (area, areaIndex) {
            _this17.updateStallNumbers(areaIndex);
          });
          _this17.$message.success('区域删除成功');
        }
      }).catch(function () {
        // 用户取消删除，不执行任何操作
      });
    },
    // 添加位置
    addLocation: function addLocation(visibleAreaIndex) {
      var _this18 = this;
      // 找到在原始数组中的实际索引
      var actualIndex = this.form.marketAreaList.findIndex(function (area) {
        return !area.isDel && area === _this18.visibleAreas[visibleAreaIndex];
      });
      var area = this.form.marketAreaList[actualIndex];
      var currentLength = area.marketStallList.filter(function (stall) {
        return !stall.isDel;
      }).length;
      area.marketStallList.push({
        id: null,
        // 新位置没有ID
        areaId: area.id || null,
        // 设置区域ID
        stallName: '',
        stallRemark: '',
        stallNum: currentLength + 1,
        isDel: false,
        // 默认未删除
        merId: this.form.merId
      });
    },
    // 删除位置
    removeLocation: function removeLocation(visibleAreaIndex, visibleLocationIndex) {
      var _this19 = this;
      // 找到在原始数组中的实际区域索引
      var actualAreaIndex = this.form.marketAreaList.findIndex(function (area) {
        return !area.isDel && area === _this19.visibleAreas[visibleAreaIndex];
      });
      var area = this.form.marketAreaList[actualAreaIndex];

      // 找到在原始位置数组中的实际索引
      var visibleStalls = area.marketStallList.filter(function (stall) {
        return !stall.isDel;
      });
      var actualLocationIndex = area.marketStallList.findIndex(function (stall) {
        return !stall.isDel && stall === visibleStalls[visibleLocationIndex];
      });
      var location = area.marketStallList[actualLocationIndex];
      var locationName = location.stallName || "\u4F4D\u7F6E".concat(visibleLocationIndex + 1);
      var areaName = area.areaName || "\u533A\u57DF".concat(visibleAreaIndex + 1);
      this.$modal.confirm("\u786E\u8BA4\u5220\u9664\"".concat(areaName, "\"\u4E2D\u7684\"").concat(locationName, "\"\u5417\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\uFF01")).then(function () {
        // 如果位置有ID，设置isDel为true；否则直接从数组中移除
        if (location.id) {
          location.isDel = true;
          _this19.$message.success('位置已标记为删除');
        } else {
          // 新添加的位置没有ID，直接从数组中移除
          area.marketStallList.splice(actualLocationIndex, 1);
          // 删除后重新计算所有摊位的编号
          _this19.updateStallNumbers(actualAreaIndex);
          _this19.$message.success('位置删除成功');
        }
      }).catch(function () {
        // 用户取消删除，不执行任何操作
      });
    },
    // 更新摊位编号
    updateStallNumbers: function updateStallNumbers(areaIndex) {
      var marketStallList = this.form.marketAreaList[areaIndex].marketStallList;
      var stallNumber = 1;
      marketStallList.forEach(function (stall) {
        if (!stall.isDel) {
          stall.stallNum = stallNumber++;
        }
      });
    },
    // 上传摊位分布图
    uploadLayoutImages: function uploadLayoutImages() {
      if (this.isDisabled) return;
      var _this = this;
      this.$modalUpload(function (imgs) {
        var _this$form$marketLayo;
        if (!imgs) return;
        var newImages = imgs.map(function (img) {
          return img.sattDir;
        });
        var remainingSlots = 9 - _this.form.marketLayoutImgs.length;
        var imagesToAdd = newImages.slice(0, remainingSlots);
        (_this$form$marketLayo = _this.form.marketLayoutImgs).push.apply(_this$form$marketLayo, _toConsumableArray(imagesToAdd));
        if (newImages.length > remainingSlots) {
          _this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F209\u5F20\u56FE\u7247\uFF0C\u5DF2\u81EA\u52A8\u9009\u62E9\u524D".concat(remainingSlots, "\u5F20"));
        }
      }, 'marketLayoutImgs', 'selfUpload', {
        multiple: true,
        maxCount: 9
      });
    },
    // 删除摊位分布图
    removeLayoutImage: function removeLayoutImage(index) {
      this.form.marketLayoutImgs.splice(index, 1);
    },
    // 上传集市图片
    uploadMarketImages: function uploadMarketImages() {
      if (this.isDisabled) return;
      var _this = this;
      this.$modalUpload(function (imgs) {
        var _this$form$marketImgs;
        if (!imgs) return;
        var newImages = imgs.map(function (img) {
          return img.sattDir;
        });
        var remainingSlots = 20 - _this.form.marketImgs.length;
        var imagesToAdd = newImages.slice(0, remainingSlots);
        (_this$form$marketImgs = _this.form.marketImgs).push.apply(_this$form$marketImgs, _toConsumableArray(imagesToAdd));
        if (newImages.length > remainingSlots) {
          _this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F2020\u5F20\u56FE\u7247\uFF0C\u5DF2\u81EA\u52A8\u9009\u62E9\u524D".concat(remainingSlots, "\u5F20"));
        }
      }, 'marketImgs', 'selfUpload', {
        multiple: true,
        maxCount: 20
      });
    },
    // 删除集市图片
    removeMarketImage: function removeMarketImage(index) {
      this.form.marketImgs.splice(index, 1);
    },
    uploadMarketOwnerPhoto: function uploadMarketOwnerPhoto() {
      if (this.isDisabled) return;
      var _this = this;
      this.$modalUpload(function (imgs) {
        if (!imgs || imgs.length === 0) return;
        var firstImage = imgs[0];
        var imageUrl = firstImage && (firstImage.sattDir || firstImage.url || firstImage.path || '');
        if (imageUrl) {
          _this.form.marketOwnerPhoto = imageUrl;
        }
      }, 'marketOwnerPhoto', 'selfUpload', {
        multiple: false,
        maxCount: 1
      });
    },
    removeMarketOwnerPhoto: function removeMarketOwnerPhoto() {
      this.form.marketOwnerPhoto = '';
    },
    // 关闭标签页
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        if (view.name === 'Dashboard') {
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    }
  }
};